const defaultState: any[] = []

export const SET_TRADE_HISTORY = 'SET_TRADE_HISTORY';

export const tradeHistoriesReducer = (state = defaultState, action: any) => {
    const { type } = action;
    if (type === SET_TRADE_HISTORY) return action.data;
    return state;
}